// paywallStore.ts — tiny open/close switch for the native MembershipPaywall so any
// wall or row can open it without prop-drilling. Rendered once, in App.
import React from 'react';

let open = false;
const subs = new Set<() => void>();
const emit = () => subs.forEach((f) => f());

export const openPaywall = (): void => { open = true; emit(); };
export const closePaywall = (): void => { open = false; emit(); };

export function usePaywallOpen(): boolean {
  return React.useSyncExternalStore(
    (cb) => { subs.add(cb); return () => { subs.delete(cb); }; },
    () => open,
  );
}
